import { useCallback } from 'react';
import emailPipelineService from '../services/emailPipelineService';
import showToast from '../../../utils/toastUtils';

const DEFAULT_ATTACHMENT_FILE_NAME = 'attachment';

export const useEmailPipelineAttachmentDownload = () =>
  useCallback(async (path: string, fileName: string) => {
    try {
      const blob = await emailPipelineService.getAttachmentBlob(path);
      const blobUrl = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = blobUrl;
      anchor.download = fileName || DEFAULT_ATTACHMENT_FILE_NAME;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Failed to download email pipeline attachment', error);
      showToast.error('Failed to download attachment. Please try again.');
    }
  }, []);

